import { COMPLETELY_LOADED_DEFAULT } from '@/lib/constants';

export const defaultExclusionCheck = (entity, context) => entity.completelyLoaded.includes(COMPLETELY_LOADED_DEFAULT);

export default function useDefaultExclusionCheck() {
  const shouldExclude = (entity, context) => defaultExclusionCheck(entity, context);

  return { shouldExclude };
}
